import { render, staticRenderFns } from "./ContactRequestDetailsView.vue?vue&type=template&id=c3e2f52c&scoped=true"
import script from "./ContactRequestDetailsView.vue?vue&type=script&lang=ts"
export * from "./ContactRequestDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./ContactRequestDetailsView.vue?vue&type=style&index=0&id=c3e2f52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e2f52c",
  null
  
)

export default component.exports